import React, { useRef } from 'react';
import { TextField, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { StyledInputContainer, StyledFormLegend, StyledInputGroup } from './DatePicker.styled';

export default function DatePicker(props) {
  const { label, day, month, year, setDay, setMonth, setYear } = props;
  const intl = useIntl();

  const dayInputRef = useRef(null);
  const monthInputRef = useRef(null);
  const yearInputRef = useRef(null);

  const handleDayChange = (event) => {
    if (/^([0-9]\d*)$/.test(event.target.value) || event.target.value === '') {
      if (event.target.value.length <= 2) {
        setDay(event.target.value);
      }

      if (event.target.value.length > 1) {
        monthInputRef.current.focus();
      }
    }
  };

  const handleMonthChange = (event) => {
    if (/^([0-9]\d*)$/.test(event.target.value) || event.target.value === '') {
      if (event.target.value.length <= 2) {
        setMonth(event.target.value);
      }

      if (event.target.value.length > 1) {
        yearInputRef.current.focus();
      }
    }
  };

  const handleYearChange = (event) => {
    if (/^([0-9]\d*)$/.test(event.target.value) || event.target.value === '') {
      if (event.target.value.length <= 4) {
        setYear(event.target.value);
      }
    }
  };

  return (
    <fieldset>
      {label && (
        <StyledFormLegend>
          <Typography variant="h3">{label}</Typography>
        </StyledFormLegend>
      )}

      <StyledInputGroup>
        <StyledInputContainer>
          <TextField
            fullWidth
            id="date"
            name="date"
            placeholder={intl.formatMessage({ id: 'dentolo.day_placeholder' })}
            value={day || ''}
            onChange={handleDayChange}
            required
            autoFocus
            inputRef={dayInputRef}
            slotProps={{
              htmlInput: {
                'data-testid': 'day',
                'inputMode': 'numeric',
                'min': '1',
                'max': '31',
                'step': '1',
              },
              input: {
                autoComplete: 'off',
              },
            }}
          />
        </StyledInputContainer>

        <StyledInputContainer>
          <TextField
            fullWidth
            id="month"
            name="month"
            placeholder={intl.formatMessage({ id: 'dentolo.month_placeholder' })}
            value={month || ''}
            onChange={handleMonthChange}
            required
            inputRef={monthInputRef}
            slotProps={{
              htmlInput: {
                'data-testid': 'month',
                'inputMode': 'numeric',
                'min': '1',
                'max': '12',
                'step': '1',
              },
              input: {
                autoComplete: 'off',
              },
            }}
          />
        </StyledInputContainer>

        <StyledInputContainer>
          <TextField
            fullWidth
            id="year"
            name="year"
            placeholder={intl.formatMessage({ id: 'dentolo.year_placeholder' })}
            value={year || ''}
            onChange={handleYearChange}
            required
            inputRef={yearInputRef}
            slotProps={{
              htmlInput: {
                'data-testid': 'year',
                'inputMode': 'numeric',
                'step': '1',
              },
              input: {
                autoComplete: 'off',
              },
            }}
          />
        </StyledInputContainer>
      </StyledInputGroup>
    </fieldset>
  );
}
